import { render, staticRenderFns } from "./faceError.vue?vue&type=template&id=02b68d0e&scoped=true"
import script from "./faceError.vue?vue&type=script&lang=js"
export * from "./faceError.vue?vue&type=script&lang=js"
import style0 from "./faceError.vue?vue&type=style&index=0&id=02b68d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b68d0e",
  null
  
)

export default component.exports